/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card :loading="loading" style="margin-bottom:1rem">
      <div slot="title">
        <a-button
          @click="backButton()"
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
        />
        <span class="hover-title main-card-title"
          >&nbsp;
          <a-icon type="tag"></a-icon>
          Detalle de Transacción
          <span style="font-size:1rem" class="title-id" v-if="transaction">
            #{{ transaction.id }}</span
          ></span
        >

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>

      <!-- <template class="ant-card-actions" slot="actions">
        <a-icon type="setting" />
        <a-icon type="edit" />
        <a-icon type="ellipsis" />
      </template> -->

      <div
        slot="extra"
        style="margin-left:1em"
        checkedChildren="Activa"
        unCheckedChildren="Inactiva"
        defaultChecked
        disabled
      ></div>
      <a-button
        @click="sendInvoiceToCustomer()"
        type="primary"
        size="small"
        style="padding-top:2px; margin-bottom:2rem"
        icon="right"
        :loading="sendInvoiceLoader"
      >
        <!--<a-icon type="like" style="margin-right:0.5em" />-->Enviar
        Comprobante de Pago
      </a-button>

      <a-card v-if="transaction">
        <div style="margin-bottom: 1.5rem">
          <h3>
            <strong>DETALLE</strong>
          </h3>
          <h3>
            {{ transaction.description }}
          </h3>
          <h3>
            <strong>Monto:</strong> $ {{ transaction.amount }}
            <a-tag
              color="green"
              style="font-size:13px; cursor:default"
              v-if="this.transaction.freeTrialDays"
            >
              {{ transaction.freeTrialDays }} días de prueba</a-tag
            >
          </h3>
          <h3>
            <strong>Fecha:</strong>
            {{ transaction.dateProcessed | moment("DD/MM/YYYY HH:mm:ss") }}
          </h3>
          <h3>
            <strong>Estado:</strong>&nbsp;
            <span style="vertical-align:text-top">
              <a-tooltip placement="right" style="cursor:default;">
                <span v-if="transaction.errorDescription" slot="title">
                  <p style="margin-bottom:1rem">
                    {{ makeErrorReadable(transaction.errorDescription) }}
                  </p>
                </span>

                <a-tag v-if="transaction.refunded" color="orange"
                  >Reintegrado <a-icon type="undo" :rotate="130"
                /></a-tag>
                <span v-else-if="transaction.statusId == '1'">
                  <a-tag color="orange"
                    >Pendiente <a-icon type="minus-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '2'">
                  <a-tag color="green" style="cursor:default"
                    >Pagado <a-icon type="check-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '9'">
                  <a-tag color="green" style="cursor:default"
                    >Pre-Aprobado <a-icon type="check-circle"
                  /></a-tag>
                </span>
                <span v-if="transaction.statusId == '3'">
                  <a-tag color="orange"
                    >Revisión <a-icon type="minus-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '4'">
                  <a-tag color="organge"
                    >En Disputa <a-icon type="minus-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '5'">
                  <a-tag color="pink"
                    >Rechazado <a-icon type="close-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '6'">
                  <a-tag color="pink"
                    >Cancelado <a-icon type="close-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '7'">
                  <a-tag color="orange"
                    >En Proceso <a-icon type="minus-circle"
                  /></a-tag>
                </span>
                <span v-else-if="transaction.statusId == '8'">
                  <a-tag color="pink"
                    >Error <a-icon type="close-circle"
                  /></a-tag>
                </span>
                <a-tag v-else-if="transaction.statusId == '10'" color="orange"
                  >Reintegrado <a-icon type="undo" :rotate="130"
                /></a-tag>
              </a-tooltip>
            </span>
          </h3>
          <span v-if="transaction.statusId == 10">
            <h3>
              <strong>Reintegro:</strong>
            </h3>
            <p :class="$style.details">
              {{ transaction.dateRefunded | moment("DD/MM/YYYY HH:mm") }}
              <br />
              A reintegrar:
              {{
                new Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS"
                }).format(transaction.amountRefunded)
              }}
              <br />
              Cursado por: {{ transaction.refunder.name }}
            </p>
          </span>
        </div>

        <div>
          <h3>
            <strong>Cliente:</strong>
          </h3>
          <p :class="$style.details">
            {{ transaction.paymentCard.customer.firstName }}
            {{ transaction.paymentCard.customer.lastName }}<br />
            <span v-if="transaction.paymentCard.customer.DNI">
              DNI: {{ transaction.paymentCard.customer.DNI }}<br
            /></span>
            <span v-if="transaction.paymentCard.customer.phone1"
              >Tel: {{ transaction.paymentCard.customer.phone1 }}<br
            /></span>
            <span v-if="transaction.paymentCard.customer.email"
              >Email: {{ transaction.paymentCard.customer.email }}</span
            >
          </p>
        </div>
        <div>
          <h3>
            <strong>Medio de Pago:</strong>
          </h3>
          <p :class="$style.details">
            {{ transaction.paymentCard.ownerName }}
            <span style="font-size:smaller" v-if="transaction.paymentCard">
              (DNI: {{ transaction.paymentCard.ownerId }})</span
            ><br />
            {{ transaction.cardType }} XXXX-XXXX-XXXX-{{
              transaction.paymentCard.lastFourDigits
            }}<br />
            Expira:
            {{ transaction.paymentCard.expirationDate | moment("MM/YY") }}
          </p>
        </div>
        <div>
          <h3>
            <strong>Datos Contables:</strong>
          </h3>
          <p :class="$style.details">
            PROD: {{ transaction.product.name
            }}<span
              style="font-size:smaller"
              v-if="transaction.product"
              :class="$style.hideMobile"
            >
              ({{ transaction.product.ERPCode }})</span
            ><br />
            CC: {{ transaction.costCenter.name
            }}<span
              style="font-size:smaller"
              v-if="transaction.costCenter"
              :class="$style.hideMobile"
            >
              ({{ transaction.costCenter.ERPCode }})</span
            ><br />
            UN: {{ transaction.businessUnit.name
            }}<span
              style="font-size:smaller"
              v-if="transaction.businessUnit"
              :class="$style.hideMobile"
            >
              ({{ transaction.businessUnit.ERPCode }})</span
            >
          </p>
        </div>
        <h3 v-if="transaction.subscription">
          <strong>Suscripción:</strong>
          {{ transaction.subscription.name }}
        </h3>
        <h3 v-if="transaction.seller">
          <strong>Vendedor:</strong>
          {{ transaction.seller.name }}
        </h3>
      </a-card>
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";
import gateway from "@/services/gateway";
import utils from "@/services/utils";

export default {
  data() {
    return {
      loading: true,
      editIcon: false,
      sendInvoiceLoader: false,
      transaction: null,
      dateFormat: "DD/MM/YYYY",
      options: []
    };
  },
  props: ["transactionId"],
  methods: {
    ...mapActions({
      loadTransaction: "transactions/loadOne",
      sendInvoice: "transactions/sendInvoice"
    }),
    backButton() {
      //this.$emit("backClick");
      this.$router.push(`/transactions`);
    },
    async fetchTransaction() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        const result = await this.loadTransaction(this.$route.params.id);
        this.loading = false;
        this.transaction = store.state.transactions.transactionDetails;
        this.transaction.cardType = this.transaction.paymentCard.paymentCourier.name;
        this.transaction.paymentCard.customer.phone1 = utils.formatPhone(
          this.transaction.paymentCard.customer.phone1
        );
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    handleRoute() {
      if (this.$route.name == "transactionDetails") this.fetchTransaction();
    },
    makeErrorReadable(err) {
      let message;
      if (err.slice(0, 1) == "{") {
        const jsonErr = JSON.parse(err);
        if (jsonErr.message) message = jsonErr.message;
        else message = gateway.humanizeDecidirError(jsonErr);
      } else message = err;
      return message;
    },
    async sendInvoiceToCustomer() {
      try {
        const x = 10;
        //console.log("params:", params);
        //const id = ;this.$router.params.id
        this.sendInvoiceLoader = true;
        const result = await this.sendInvoice(this.$route.params.id);
        this.sendInvoiceLoader = false;
        this.$notification["success"]({
          message: "Éxito",
          description: result
        });
      } catch (error) {
        this.sendInvoiceLoader = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO MANUAL URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
}
.ant-card-body {
  padding-bottom: 9px;
  padding: 17px 32px;
}
/*
.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  left: 0;
  line-height: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 20px;
}
.ant-btn-link {
  border: none;
}
*/
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
/*
.back-button:hover {
  background-color: #0190fe;
  border-color: #0190fe;
  color: #fff;
}*/
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
/*
h3 {
  font-size: 1.2rem;
}
strong {
  font-weight: normal;
  color: black;
}*/
@media (max-width: 767px) {
  .ant-card-head-wrapper {
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: 1rem !important;
    align-self: flex-end;
    vertical-align: middle;
    padding-bottom: 1.28rem;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-transaction-button {
    display: inline !important;
  }
  .edit-icon {
    display: none !important;
  }
}
.edit-icon {
  display: none;
  font-size: 13px;
  color: #aaa;
  vertical-align: -0rem;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
.btn-edit-transaction {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
